export default "__VITE_ASSET__Wvb$P8Sb__"